'use strict';

/**
 * Обработка ответа от сервера
 * @module
 */

// ----------------------------------------
// Private
// ----------------------------------------

/**
 * Вывод уведомлений
 * @param {JQuery} $form
 * @param {string} message
 * @param {boolean} [success]
 * @private
 */
function showMessage ($form, message, success) {
	let msgStatus = success ? 'success' : 'error';
	window.Noty[msgStatus](message);
};

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * @param {JQuery} $form
 * @param {Object} response
 * @param {string} statusText
 * @param {Object} xhr
 * @param {string} response.response - текстовое сообщение
 * @param {boolean} response.success - успешный запрос
 * @param {string} [response.redirect] - урл для редиректа, если равен текущему урлу - перегражаем страницу
 * @param {boolean} [response.reload] - перегрузить страницу
 * @param {boolean} [response.reset] - сбросить форму
 * @param {Array} [response.clear] - сбросить форму
 * @private
 */
function getResponse ($form, response, statusText, xhr) {
	let preloader = $form.data('preloader');

	// обрабатываем ответ
	// ------------------
	if (typeof response === 'string') {
		response = JSON.parse(response);
	}

	if (response.reload || window.location.href === response.redirect) {
		return window.location.reload();
	}

	if (response.redirect) {
		return (window.location.href = response.redirect);
	}

	if (response.success) {
		if (response.clear) {
			if (Array.isArray(response.clear)) {
				response.clear.forEach(clearSelector => {
					$form.find(clearSelector).val('');
				});
			} else {
				// игнорируемые типы инпутов
				let ignoredInputsType = [
					'submit',
					'reset',
					'button',
					'image'
				];
				$form.find('input, textarea, select').each((i, element) => {
					if (~ignoredInputsType.indexOf(element.type)) {
						return true;
					}
					element.value = '';
				});
			}
		} else if (response.reset) {
			$form.trigger('reset');
		}

		if ($form.data('append-response')) {
			let target = $($form.closest('[data-append-response-target]')).length > 0 ? $($form.closest('[data-append-response-target]')) : $form.parents('[data-form-container]').find('[data-append-response-target]');
			target.html(response.response);
			target.addClass('visible');
			$(document).on('click', '[data-close-modal]', function () {
				target.removeClass('visible');
			});
		}
	}

	if (response.noty) {
		showMessage($form, response.response, response.success);
	}

	preloader.hide();
}

// ----------------------------------------
// Exports
// ----------------------------------------

export default getResponse;



// WEBPACK FOOTER //
// ./_HTML/src/js/_modules/validation/get-response.js